<form *ngIf="form" [formGroup]="form">
  <div class="row no-gutters" *ngIf="!readOnly">
    <div class="col-12 pr-lg-1" [ngClass]="{'col-lg-4': pricing, 'col-lg-9': !pricing}">
      <div class="row pb-1">
        <div class="col-1 pt-2 pl-1 pr-0 text-right">
          <i class="material-icons" *ngIf="item.serviceAgreement">content_paste</i>
          <i class="material-icons" *ngIf="item.task">business_center</i>
          <i class="material-icons" *ngIf="!(item.serviceAgreement || item.task)">attach_money</i>
        </div>
        <div class="col-11 pl-1">
          <app-product-autocomplete [text]="item.detail" (selected)="onSelected($event)"
            (textChange)="onChanged($event)" [readOnly]="readOnly">
          </app-product-autocomplete>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-block d-lg-none">
          <mat-form-field appearance="outline">
            <mat-label>Descripción</mat-label>
            <input matInput type="text" formControlName="description" [readonly]="readOnly" placeholder="Descripción"
              (input)="calculateTotals()" [errorStateMatcher]="customErrorStateMatcher">
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12" [ngClass]="{'col-lg-7': pricing, 'col-lg-2': !pricing}">
      <div class="row no-gutters">
        <div class="col-6 pl-1" [ngClass]="{'col-md-1': pricing, 'col-md-12': !pricing}">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Cantidad</mat-label>
            <input matInput name="quantity" formControlName="quantity" type="number" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Unidad</mat-label>
            <mat-select formControlName="unit" (selectionChange)="calculateTotals()" [ngClass]="{'readonly-select': readOnly}"
              [disabled]="readOnly">
              <mat-option *ngFor="let unit of unitListKeys" [value]="unit">{{unitList[unit]}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Costo</mat-label>
            <input matInput name="cost" formControlName="cost" type="number" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Precio</mat-label>
            <input matInput name="price" formControlName="price" type="number" (input)="calculateTotals()"
              [readonly]="readOnly">
          </mat-form-field>
        </div>
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Subtotal</mat-label>
            <input matInput type="text" class="number" formControlName="subtotal" readonly>
          </mat-form-field>
        </div>
        <div class="col-6 col-md-1 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline" *ngIf="f['taxPercentage'].value != undefined">
            <mat-label class="d-lg-none d-block">(%)Impuestos</mat-label>
            <input matInput type="text" class="number" formControlName="taxPercentage" [readonly]="readOnly"
              (input)="calculateTotals()">
          </mat-form-field>
          <div class="text-right pt-4" *ngIf="f['taxPercentage'].value == undefined" style="width: 100%"> </div>
        </div>
        <!-- <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Impuestos</mat-label>
            <input matInput type="text" class="number" formControlName="tax" readonly>
          </mat-form-field>
        </div> -->
        <div class="col-6 col-md-2 pl-2" *ngIf="pricing">
          <mat-form-field appearance="outline">
            <mat-label class="d-lg-none d-block">Total</mat-label>
            <input matInput type="text" class="number" formControlName="total" readonly>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-1 pl-lg-1" style="display: flex; align-items: center;" *ngIf="!readOnly">
      <button class="btn btn-outline p-1 m-0" (click)="removeItem()" style="margin-left: auto; margin-top: auto;">
        <i class="material-icons">delete</i>
      </button>
    </div>


    <div class="col-11 d-none d-lg-block pl-4">
      <mat-form-field appearance="outline">
        <mat-label>Descripción</mat-label>
        <input matInput type="text" formControlName="description" [readonly]="readOnly" (input)="calculateTotals()"
          [errorStateMatcher]="customErrorStateMatcher">
      </mat-form-field>
    </div>
  </div>

  <!-- ------readOnly------- -->

  <div class="row mx-1" *ngIf="readOnly">
    <div class="col-12 mb-1 mt-1 pb-1" style="border-radius: 8px; border-bottom: 1px solid #EAE8F5;">
      <div class="row">
        <div class="col-12 d-flex align-items-center justify-content-center"
          [ngClass]="{'col-lg-4': pricing, 'col-lg-9': !pricing}">
          <div class="col-12 pl-2 text-left bold-item text-md-left text-center">
            {{item.detail}}
          </div>
        </div>

        <div class="col-12" [ngClass]="{'col-lg-7': pricing, 'col-lg-2': !pricing}">
          <div class="row align-items-center">
            <div [ngClass]="{'col-6 col-md-1': pricing, 'col-12': !pricing}" class="text-center">
              <div class="d-md-none d-inline">Cantidad: </div>
              {{item.quantity}}
            </div>

            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Unidad: </div>
              {{item.unit}}
            </div>
            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Costo: </div>
              {{item.cost || 0  | money: { needSymbol:false } }}
            </div>
            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Precio: </div>
              {{item.price || 0  | money: { needSymbol:false } }}
            </div>
            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Subtotal: </div>
              {{item.subtotal || 0  | money: { needSymbol:false } }}
            </div>
            <div class="col-6 col-md-1 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Impuesto: </div>
              {{item.taxPercentage}}%
            </div>
            <div class="col-6 col-md-2 text-center" *ngIf="pricing">
              <div class="d-md-none d-inline">Total: </div>
              {{item.total || 0  | money: { needSymbol:false } }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 px-4 text-md-left text-center" *ngIf="pricing">
          <div class="d-md-none d-inline">Descripción:</div>
          &nbsp;{{item.description}}
        </div>
      </div>
    </div>

  </div>
</form>